import script from "./RssIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./RssIcon.vue?vue&type=script&setup=true&lang=js"

import "./RssIcon.vue?vue&type=style&index=0&id=59850798&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59850798"]])

export default __exports__